import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMe } from '../../hooks';
import { articlesForProject, articles } from '../../content/wechat';
import { directionProjects, moreProjects } from '../../content/research-projects';

export default function Home() {
  const me = useMe();
  const user = me.data ?? null;
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#research') {
      document.getElementById('research')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [location.hash]);

  return (
    <div className="home-showcase">
      <section className="showcase-hero">
        <div className="showcase-hero-inner">
          <img
            className="showcase-owner"
            src="/brand/lab-logo-light.png"
            alt="碳捕集与能源利用数智实验室"
          />
          <h1>
            把碳捕集研究，
            <br />
            放到每个人都能看到的屏幕上。
          </h1>
          <p>
            已开展的方向共用一套中试装置与数据平台，另有两个方向正在筹备。实时监控、历史回放与采集数据，都从同一个入口进入。
          </p>
          <div className="showcase-actions">
            <Link to="/ccs/live" className="btn btn-primary">
              进入 CCS 系统
            </Link>
            <a href="#research" className="btn btn-ghost">
              查看研究方向
            </a>
          </div>
          <div className="showcase-stats">
            <div>
              <b>{directionProjects.length}</b>
              <span>研究方向</span>
            </div>
            <div>
              <b>78</b>
              <span>采集通道</span>
            </div>
            <div>
              <b>63</b>
              <span>P&amp;ID 测点</span>
            </div>
            <div>
              <b>{articles.length}</b>
              <span>公众号文章</span>
            </div>
          </div>
        </div>
      </section>

      <section id="research" className="research">
        <div className="section-head research-head">
          <div>
            <div className="eyebrow">Research</div>
            <h2>研究方向</h2>
          </div>
          <p>船载系统与紧凑换热已开展，强化吸收与强化解吸正在筹备。</p>
        </div>

        {directionProjects.map((project, index) => {
          const count = articlesForProject(project.id).length;
          return (
            <article key={project.id} className={`research-row${index % 2 ? ' reverse' : ''}`}>
              <Link to={`/research/${project.id}`} className="research-media">
                <img src={project.cover} alt={project.title} />
              </Link>
              <div className="research-body">
                <div className="eyebrow">
                  0{index + 1} · {project.kicker}
                </div>
                <h3>
                  <Link to={`/research/${project.id}`}>{project.title}</Link>
                </h3>
                <p className="research-lead">{project.summary}</p>
                <p className="research-text">{project.intro[0]}</p>
                <div className="badge-row">
                  <span className={`badge ${project.status === 'planned' ? 'warn' : 'ok'}`}>
                    {project.status === 'planned' ? '筹备中' : '已开展'}
                  </span>
                  {project.tags.map((tag) => (
                    <span key={tag} className="badge">
                      {tag}
                    </span>
                  ))}
                </div>
                <Link to={`/research/${project.id}`} className="research-foot">
                  {project.status === 'planned' ? (
                    <>
                      <span>拟开展</span>
                      <span>查看方向 →</span>
                    </>
                  ) : (
                    <>
                      <span>{count} 篇相关研究</span>
                      <span>查看项目 →</span>
                    </>
                  )}
                </Link>
              </div>
            </article>
          );
        })}
      </section>

      <section className="research-more">
        <div className="section-head">
          <div>
            <div className="eyebrow">More</div>
            <h2>更多研究与动态</h2>
          </div>
          <p className="muted">其他论文、获奖、会议与团队活动。</p>
        </div>
        <div className="more-grid">
          {moreProjects.map((project) => (
            <Link key={project.id} to={`/research/${project.id}`} className="more-card">
              <div className="more-card-cover">
                <img src={project.cover} alt={project.title} />
              </div>
              <div className="more-card-body">
                <div className="eyebrow">{project.kicker}</div>
                <h3>{project.title}</h3>
                <p>{project.summary}</p>
                <span>{articlesForProject(project.id).length} 篇 →</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="showcase-cta">
        <div>
          <div className="eyebrow">CCS System</div>
          <h2>从研究到装置，数据都在这里。</h2>
          <p>监控设备状态、回放历史实验、查看采集数据。登录后可进入实时画面与控制。</p>
        </div>
        <div className="showcase-cta-actions">
          <Link to="/ccs/live" className="btn btn-primary">
            进入 CCS 系统
          </Link>
          {user ? null : (
            <Link to="/login" className="btn btn-ghost">
              登录
            </Link>
          )}
        </div>
      </section>
    </div>
  );
}